import React, { useState } from "react";
import RecipientAddressForm from "./RecipientAddressForm";

import { useApi } from "../../../../../api";
import useI18nSnackbar from "../../../../../hooks/useI18nSnackbar";

const RecipientContainer = ({ device, onClose }) => {
  const api = useApi();
  const { enqueueSnackbar } = useI18nSnackbar();
  const [isSubmitting, setSubmitting] = useState(false);

  const handleSubmit = recipientAddress => {
    setSubmitting(true);

    api
      .put(`/v2/devices/${device.id}/billing-recipient`, {
        order_number: device.orderNumber,
        recipient_address: recipientAddress
      })
      .then(() => {
        enqueueSnackbar("devices.settings.billing.responses.debtorUpdated", {
          variant: "success"
        });

        setSubmitting(false);
        onClose(true);
      })
      .catch(e => {
        setSubmitting(false);
        if (!e.response) {
        }
      });
  };

  return (
    <RecipientAddressForm
      value={device.recipientAddress}
      onClose={onClose}
      onSubmit={handleSubmit}
      isSubmitting={isSubmitting}
    />
  );
};

export default RecipientContainer;
